export const guidanceConstants = {
  REGISTER_REQUEST: 'GUIDANCE_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'GUIDANCE_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'GUIDANCE_REGISTER_FAILURE',

  GET_REQUEST: 'GUIDANCE_GET_REQUEST',
  GET_SUCCESS: 'GUIDANCE_GET_SUCCESS',
  GET_FAILURE: 'GUIDANCE_GET_FAILURE',

  GETALL_REQUEST: 'GUIDANCE_GETALL_REQUEST',
  GETALL_SUCCESS: 'GUIDANCE_GETALL_SUCCESS',
  GETALL_FAILURE: 'GUIDANCE_GETALL_FAILURE',

  DELETE_REQUEST: 'GUIDANCE_DELETE_REQUEST',
  DELETE_SUCCESS: 'GUIDANCE_DELETE_SUCCESS',
  DELETE_FAILURE: 'GUIDANCE_DELETE_FAILURE',
};